<template>
  <div class="edit-quiz-page container">
    <h1 class="title">
      Editar Desafio
      <button
        disabled="disabled"
        class="button is-loading is-disabled is-white"
        style="background-color: #f5f5f5"
        v-if="isLoading"
      >
        ...
      </button>
    </h1>
    <div class="page-content">
      <tabs type="toggle">
        <tab-item label="Dados do Desafio">
          <quiz-form
            :on-submit="updateQuiz"
            :is-disabled="isFormDisabled"
            :is-loading="isFormDisabled"
            :form-data="getQuiz"
            button-label="Atualizar pergunta"
          />
        </tab-item>
        <tab-item label="Respostas do Desafio">
          <h4 class="title is-5" v-if="hasAnswers">Respostas adicionadas:</h4>
          <answer-viewer
            v-for="answer in getAnswers"
            :key="answer.id"
            :answer="addFieldsToAnswer(answer)"
            :can-be-edited="true"
            :can-be-deleted="me.role !== 'moderator'"
            :can-be-updated="true"
            :on-delete="RemoveAnswerToQuiz"
          />
          <h4 class="title is-5" v-if="hasAnswers && me.role !== 'moderator'">Adicionar nova Resposta:</h4>
          <answer-form
            :on-submit="addAnswer"
            :is-disabled="isAnswerFormDisabled"
            :is-loading="isAnswerFormDisabled"
            :form-data="GetAnswerFormData"
            button-label="Adicionar outra"
            v-if="me.role !== 'moderator'"
          />
        </tab-item>
      </tabs>
      <p class="has-text-centered">
        <router-link :to="`/${$route.params.lang}/places/${$route.params.id}`" class="button is-link">Visualizar Lugar</router-link>
        <router-link :to="`/${$route.params.lang}/places`" class="button is-link">Voltar para listagem de Lugares</router-link>
      </p>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import AsideMenuCtrlMixin from './AsideMenuCtrlMixin'
import AnswerViewer from '../QuizAnswerViewer'
import QuizForm from '../forms/QuizForm'
import AnswerForm from '../forms/AnswerForm'
import { CreateQuizAnswer } from '../../api/quiz'

export default {
  name: 'EditQuizPage',
  mixins: [AsideMenuCtrlMixin],
  components: { AnswerViewer, QuizForm, AnswerForm },
  data () {
    return {
      isLoading: false,
      isFormDisabled: false,
      isAnswerFormDisabled: false,
      answerFormData: {
        text: '',
        correct: false
      }
    }
  },
  computed: {
    ...mapGetters(['PlaceQuizes', 'me']),
    GetAnswerFormData () {
      return { ...this.answerFormData, language: this.$route.query.lang || 'pt' }
    },
    hasAnswers () {
      const { lang } = this.$route.query
      return this.PlaceQuizes[lang] && this.PlaceQuizes[lang][0].answers.length > 0
    },
    getAnswers () {
      const { lang } = this.$route.query
      if (this.PlaceQuizes[lang]) {
        return this.PlaceQuizes[lang][0].answers
      }
      return []
    },
    getQuiz () {
      const { lang } = this.$route.query
      if (this.PlaceQuizes[lang]) {
        return this.PlaceQuizes[lang][0]
      }
      return {}
    }
  },
  methods: {
    ...mapActions([
      'RetrievePlaceQuizes',
      'AddAnswerToQuiz',
      'RemoveAnswerToQuiz',
      'UpdateQuiz'
    ]),
    addFieldsToAnswer (answer) {
      return {
        ...answer,
        PlaceQuizId: this.$route.params.id,
        quizId: this.getQuiz.id
      }
    },
    updateQuiz (data) {
      let formData = {
        params: {
          placeId: this.$route.params.id,
          quizId: data.id,
          languageId: data.languageId
        },
        quiz: data
      }
      this.isLoading = true
      this.isFormDisabled = true
      this.UpdateQuiz(formData)
        .then(
          success => {
            this.isLoading = false
            this.isFormDisabled = false
            this.$notify.open({
              type: 'success',
              content: 'Desafio atualizado com sucesso.',
              duration: 10000
            })
          },
          error => {
            this.isLoading = false
            this.isFormDisabled = false
            console.log(error.response)
            this.$notify.open({
              type: 'danger',
              content: 'Não foi possível atualizar o Desafio.',
              duration: 10000
            })
          }
        )
    },
    addAnswer (data) {
      this.isAnswerFormDisabled = true
      CreateQuizAnswer(
        data,
        this.$route.params.id,
        this.getQuiz.id,
        this.$route.query.lang
      )
        .then(
          success => {
            // console.log(success.data)
            this.AddAnswerToQuiz(success.data)
            this.isAnswerFormDisabled = false
            this.answerFormData = {
              text: '',
              correct: false
            }
            this.$notify.open({
              type: 'success',
              content: 'Resposta adicionada com sucesso.',
              duration: 10000
            })
          },
          error => {
            console.log(error.response)
            this.isAnswerFormDisabled = false
            this.$notify.open({
              type: 'danger',
              content: 'Não foi possível criar a Resposta agora. Tente novamente.',
              duration: 10000
            })
          }
        )
    }
  },
  created () {
    if (!this.PlaceQuizes[this.$route.query.lang]) {
      this.isLoading = true
      this.RetrievePlaceQuizes({
        params: {
          limit: null,
          skip: null,
          language: this.$route.query.lang,
          id: this.$route.params.id
        }
      })
        .then(
          success => { this.isLoading = false },
          error => {
            console.log(error.response)
            this.isLoading = false
            this.$notify.open({
              type: 'danger',
              content: 'Não foi possível obter os dados do Desafio.',
              duration: 10000
            })
          }
        )
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/pages/EditQuizPage.vue